var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linkedin 1",
    clipPath: "url(#clip0_45_202)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "linkedin--network-linkedin-professional"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.17067 4.04049C8.17682 4.83084 7.87177 5.59187 7.32141 6.15916C6.77108 6.72643 6.01963 7.05441 5.22946 7.07221C4.44093 7.04327 3.69366 6.71253 3.14205 6.14828C2.59046 5.58405 2.2767 4.82949 2.26562 4.04049C2.2999 3.2718 2.62518 2.54487 3.17556 2.00712C3.72592 1.46936 4.46018 1.161 5.22946 1.14453C5.99652 1.1613 6.72818 1.47043 7.27488 2.00873C7.82157 2.54702 8.14203 3.27381 8.17067 4.04049ZM2.58237 12.4569C2.58237 10.7148 3.69099 10.9863 5.22946 10.9863C6.76795 10.9863 7.85394 10.7148 7.85394 12.4569V29.4254C7.85394 31.1902 6.74532 30.8282 5.22946 30.8282C3.71362 30.8282 2.58237 31.1902 2.58237 29.4254V12.4569Z",
    stroke: "black",
    strokeWidth: 2.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.4219 12.456C12.4219 11.4832 12.7839 11.1212 13.3495 11.0081C13.9151 10.8949 15.8608 11.0081 16.5396 11.0081C17.2183 11.0081 17.4898 12.1167 17.4672 12.9538C18.0478 12.1746 18.8186 11.5574 19.7059 11.1612C20.5933 10.7651 21.5674 10.6033 22.5351 10.6913C23.4854 10.6332 24.4374 10.7757 25.3291 11.1095C26.2205 11.4433 27.0321 11.9609 27.7105 12.6288C28.3892 13.2966 28.9195 14.0998 29.2673 14.986C29.6152 15.8722 29.7727 16.8218 29.7297 17.7728V29.3567C29.7297 31.1215 28.6438 30.7594 27.1053 30.7594C25.5668 30.7594 24.4808 31.1215 24.4808 29.3567V20.3068C24.5206 19.841 24.4598 19.3722 24.3023 18.932C24.1448 18.4919 23.8943 18.0908 23.5681 17.756C23.242 17.4212 22.8475 17.1605 22.4116 16.9916C21.9757 16.8228 21.5085 16.7497 21.0419 16.7774C20.5774 16.7656 20.1157 16.8526 19.6874 17.0326C19.2591 17.2126 18.8739 17.4816 18.5573 17.8217C18.2407 18.1618 18 18.5653 17.8511 19.0054C17.7022 19.4455 17.6484 19.9122 17.6934 20.3747V29.4246C17.6934 31.1894 16.5848 30.8273 15.0463 30.8273C13.5079 30.8273 12.4219 31.1894 12.4219 29.4246V12.456Z",
    stroke: "black",
    strokeWidth: 2.28571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45_202"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.78ce45b099122f9c5d8acbf77e9d4352.svg";
export { ForwardRef as ReactComponent };